"use strict";

var acceptableUserCities = require('./acceptableUserCities');
var freeDefaultCities = ["New York", "Boston", "Chicago", "Los Angeles", "San Francisco", "Washington DC", "Miami", "San Diego"];
var proDefaultCities = ["Austin", "Baltimore", "Big Sur", "Boise", "Charleston", "Charlotte", "Columbus", "Detroit"];

module.exports.defaultFreeCities = acceptableUserCities.filter(function (location) {
  return freeDefaultCities.includes(location.value) && !location.premiumCity;
});

module.exports.additionalFreeCities = acceptableUserCities.filter(function (location) {
  return !freeDefaultCities.includes(location.value) && !location.premiumCity;
});

module.exports.defaultProCities = acceptableUserCities.filter(function (location) {
  return proDefaultCities.includes(location.value) && location.premiumCity;
});

module.exports.additionalProCities = acceptableUserCities.filter(function (location) {
  return location.premiumCity;
});